let MainURL = "https://1001again.com"


export default MainURL